import {GET_DEPARTMENT_SEARCH,DEPARTMENT_SEARCH_ERROR} from '../type'
import axios from 'axios';
import env from '../../ENV';
let ROOT_URL = env.BACKEND_URL;

export const getDepartmentSearch = () => async dispatch => {
    
    try{
        const res = await axios.post(`${ROOT_URL}department/search`)
        dispatch( {
            type: GET_DEPARTMENT_SEARCH,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: DEPARTMENT_SEARCH_ERROR,
            payload: console.log(e),
        })
    }

}